import * as React from 'react';

import type { IconProps } from '../../types';

/**
 * Link icon
 *
 * @category Files/Forms/Editing
 */
const Link = React.forwardRef<SVGSVGElement, IconProps>(
  ({ 'data-testid': testId, size = 20, className, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        data-testid={testId}
        width={size}
        height={size}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        role="img"
        aria-hidden="true"
        {...props}
      >
        <path
          fill="currentColor"
          d="M10.299 29c-6.037.023-9.524-7.439-5.69-12.085 1.02-1.112 2.504-3.22 3.987-3.418.266.093.058.672-.487 1.356-1.135 1.344-2.723 2.595-3.372 4.252-1.575 3.395.614 7.752 4.287 8.481 2.213.51 4.426-.278 6.072-1.83.845-.672 2.305-2.56 3.29-2.48.14.058.15.244.035.522-1.773 2.734-4.646 5.132-7.914 5.19h-.22zm13.07-10.451c-.325-.058-.128-.684.486-1.437 1.147-1.355 2.711-2.56 3.372-4.24 2.05-4.334-2.132-9.548-6.825-8.505-2.329.36-3.893 2.271-5.573 3.754-.695.545-1.274.753-1.367.487-.127-.267.348-1.078 1.078-1.82 1.726-1.807 3.545-3.417 6.082-3.707 5.006-.788 9.524 4.31 8.11 9.165-.567 2.27-3.162 5.422-5.282 6.303z"
        />
        <path
          fill="currentColor"
          d="M10.762 21.341c-.463-.232.313-1.32.707-1.703 1.935-1.958 5.967-5.967 8.018-7.995 1.39-1.436 2.572-1.077 1.077.73-2.386 2.538-5.132 5.145-7.565 7.601-.58.533-1.414 1.448-2.167 1.39z"
        />
      </svg>
    );
  }
);

Link.displayName = 'Link';

export { Link };
